import { BATTLE_ARENA_FIGHT_ROSTER } from './battleArenaFightRoster'

export type BattleArenaFightHero=(typeof BATTLE_ARENA_FIGHT_ROSTER)[number]
export type AdaptedFightFighter={id:string;name:string;title:string;assetId:string;modelUrl:string;accent:string;maxHealth:number;speed:number;power:number;scale:number;hurtHalfWidth:number}

const clamp=(value:number,min:number,max:number)=>Math.max(min,Math.min(max,value))

export function adaptBattleArenaHeroToFight(hero:BattleArenaFightHero):AdaptedFightFighter{
 const sourceHealth=hero.maxHealth>300?hero.maxHealth:920+(hero.maxHealth-80)*3.4+(hero.mass-1)*60
 return{
  id:hero.id,name:hero.name,title:hero.title,assetId:hero.assetId,
  modelUrl:`/elyon/runtime-fighters/${hero.runtimeModel}`,accent:hero.accent,
  maxHealth:Math.round(clamp(sourceHealth,900,1450)),
  speed:clamp(4.8+(hero.moveSpeed-5)*.64,4.8,7.4),
  power:clamp(.96+(hero.damage-24)*.009,.96,1.26),
  scale:1,
  hurtHalfWidth:clamp(.4+(hero.mass-.8)*.11,.4,.57),
 }
}

export const ADAPTED_BATTLE_ARENA_FIGHTERS=BATTLE_ARENA_FIGHT_ROSTER.map(adaptBattleArenaHeroToFight)
